interface DataTableProps {
  headers: string[];
  rows: string[][];
}

export const DataTable = ({ headers, rows }: DataTableProps) => (
  <div className="overflow-x-auto rounded-2xl border border-border">
    <table className="min-w-full divide-y divide-border text-sm">
      <thead className="bg-card">
        <tr>
          {headers.map((header) => (
            <th
              key={header}
              scope="col"
              className="px-4 py-3 text-left font-semibold text-muted-foreground text-xs uppercase tracking-wider"
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-border bg-card">
        {rows.map((row) => (
          <tr key={row.join("|")}>
            {row.map((cell, cellIndex) => (
              <td
                key={`${row.join("|")}-${cellIndex}`}
                className="px-4 py-3 align-top text-foreground"
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
